import EvaluationFlow from "../../../flow/EvaluationFlow"
import {
  DraftInAppMessageEligibilityFlowEvaluator,
  EligibleInAppMessageEligibilityFlowEvaluator,
  FrequencyInAppMessageEligibilityFlowEvaluator,
  HiddenInAppMessageEligibilityFlowEvaluator,
  InAppMessageEligibilityFlow,
  LayoutResolveInAppMessageEligibilityFlowEvaluator,
  OverrideInAppMessageEligibilityFlowEvaluator,
  PauseInAppMessageEligibilityFlowEvaluator,
  PeriodInAppMessageEligibilityFlowEvaluator,
  PlatformInAppMessageEligibilityFlowEvaluator,
  TargetInAppMessageEligibilityFlowEvaluator,
  TimetableInAppMessageEligibilityFlowEvaluator
} from "./InAppMessageEligibilityFlowEvaluator"
import InAppMessageHiddenStorage from "../../../target/InAppMessageHiddenStorage"
import { HackleCoreContext } from "../../../../HackleCoreContext"
import { InAppMessageImpressionStorage } from "../../../../../../hackle/iam/storage/InAppMessageImpressionStorage"
import {
  HiddenInAppMessageMatcher,
  InAppMessageFrequencyCapMatcher,
  TargetInAppMessageMatcher,
  UserOverrideInAppMessageMatcher
} from "../../../target/InAppMessageMatcher"
import TargetMatcher from "../../../match/TargetMatcher"
import { InAppMessageLayoutEvaluator } from "../layout/InAppMessageLayoutEvaluator"

export default class InAppMessageEligibilityFlowFactory {
  private readonly triggerFlow: InAppMessageEligibilityFlow
  private readonly deliverFlow: InAppMessageEligibilityFlow
  private readonly deliverReEvaluateFlow: InAppMessageEligibilityFlow

  constructor(
    inAppMessageHiddenStorage: InAppMessageHiddenStorage,
    inAppMessageImpressionStorage: InAppMessageImpressionStorage,
    private readonly layoutEvaluator: InAppMessageLayoutEvaluator
  ) {
    const targetMatcher = HackleCoreContext.get<TargetMatcher>("targetMatcher")

    const overrideFlow = [new OverrideInAppMessageEligibilityFlowEvaluator(new UserOverrideInAppMessageMatcher())]

    const evaluateFlow = [
      new PlatformInAppMessageEligibilityFlowEvaluator(),
      new OverrideInAppMessageEligibilityFlowEvaluator(new UserOverrideInAppMessageMatcher()),
      new DraftInAppMessageEligibilityFlowEvaluator(),
      new PauseInAppMessageEligibilityFlowEvaluator(),
      new PeriodInAppMessageEligibilityFlowEvaluator(),
      new TimetableInAppMessageEligibilityFlowEvaluator(),
      new TargetInAppMessageEligibilityFlowEvaluator(new TargetInAppMessageMatcher(targetMatcher))
    ]

    const layoutFlow = [new LayoutResolveInAppMessageEligibilityFlowEvaluator(this.layoutEvaluator)]

    const deduplicateFlow = [
      new FrequencyInAppMessageEligibilityFlowEvaluator(
        new InAppMessageFrequencyCapMatcher(inAppMessageImpressionStorage)
      ),
      new HiddenInAppMessageEligibilityFlowEvaluator(new HiddenInAppMessageMatcher(inAppMessageHiddenStorage))
    ]

    const eligibleFlow = [new EligibleInAppMessageEligibilityFlowEvaluator()]

    this.triggerFlow = EvaluationFlow.of(...evaluateFlow, ...layoutFlow, ...deduplicateFlow, ...eligibleFlow)

    this.deliverFlow = EvaluationFlow.of(...overrideFlow, ...deduplicateFlow, ...eligibleFlow)

    this.deliverReEvaluateFlow = EvaluationFlow.of(...evaluateFlow, ...deduplicateFlow, ...eligibleFlow)
  }

  getTriggerFlow(): InAppMessageEligibilityFlow {
    return this.triggerFlow
  }

  getDeliverFlow(reEvaluate: boolean): InAppMessageEligibilityFlow {
    return reEvaluate ? this.deliverReEvaluateFlow : this.deliverFlow
  }
}
